function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import PropTypes from "prop-types";
import React from "react";
import classnames from "classnames";
import Base from "../Base/Base";
import Modal from "../Modal/Modal";
import DialogContext from "./DialogContext";
import "./Dialog.css";
export default function Dialog(_ref) {
  let {
    children,
    className,
    closeOnOverlayClick = true,
    onRequestClose,
    overlayShade,
    overlayTheme,
    padding = "x6",
    size,
    theme = "day",
    width,
    ...rest
  } = _ref;
  const classes = classnames("ax-dialog", {
    "ax-dialog--fullscreen": size === "fullscreen",
    "ax-dialog--large": size === "large"
  }, className);
  const modalPadding = size === "fullscreen" ? "x0" : padding;
  return /*#__PURE__*/React.createElement(Modal, _extends({}, rest, {
    onOverlayClick: closeOnOverlayClick ? onRequestClose : null,
    overlayShade: overlayShade,
    overlayTheme: overlayTheme,
    padding: modalPadding
  }), /*#__PURE__*/React.createElement(Base, {
    className: classes,
    style: {
      width
    },
    theme: theme
  }, /*#__PURE__*/React.createElement(DialogContext.Provider, {
    value: {
      onRequestClose
    }
  }, children)));
}